import { useState } from "react";
import { ChevronLeft, ChevronRight, Images, X } from "lucide-react";
import { photoSrc } from "@/components/PhotoUpload";

/** Cover photo with a swipe-through viewer, so a passenger sees the actual car. */
export const VehicleGallery = ({ photos = [], name = "", testId = "vehicle-gallery" }) => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  if (!photos.length) {
    return (
      <span className="flex h-12 w-16 items-center justify-center rounded bg-ink-700 font-mono text-[10px] text-slate-500">
        CAR
      </span>
    );
  }

  const step = (delta) => setIndex((i) => (i + delta + photos.length) % photos.length);

  return (
    <>
      <button type="button" data-testid={testId}
        onClick={(e) => { e.stopPropagation(); setIndex(0); setOpen(true); }}
        className="relative shrink-0">
        <img src={photoSrc(photos[0])} alt={name} className="h-12 w-16 rounded object-cover" />
        {photos.length > 1 && (
          <span className="absolute bottom-0.5 right-0.5 flex items-center gap-0.5 rounded bg-ink-900/85 px-1 py-0.5 font-mono text-[9px] text-gold">
            <Images className="h-2.5 w-2.5" /> {photos.length}
          </span>
        )}
      </button>

      {open && (
        <div data-testid={`${testId}-viewer`} onClick={() => setOpen(false)}
          className="fixed inset-0 z-50 flex items-center justify-center bg-ink-900/95 p-4 backdrop-blur-sm">
          <div className="w-full max-w-2xl" onClick={(e) => e.stopPropagation()}>
            <div className="mb-3 flex items-center justify-between">
              <p className="font-display text-base text-slate-100">{name}</p>
              <button type="button" data-testid={`${testId}-close`} onClick={() => setOpen(false)}
                className="text-slate-400 hover:text-gold">
                <X className="h-5 w-5" />
              </button>
            </div>
            <img src={photoSrc(photos[index])} alt={name}
              className="max-h-[65vh] w-full rounded-xl border border-ink-600 object-contain" />
            {photos.length > 1 && (
              <div className="mt-4 flex items-center justify-between">
                <button type="button" data-testid={`${testId}-prev`} onClick={() => step(-1)}
                  className="rounded-full border border-ink-600 p-2 text-slate-300 hover:border-gold/40 hover:text-gold">
                  <ChevronLeft className="h-5 w-5" />
                </button>
                <span className="font-mono text-xs text-slate-500">{index + 1} / {photos.length}</span>
                <button type="button" data-testid={`${testId}-next`} onClick={() => step(1)}
                  className="rounded-full border border-ink-600 p-2 text-slate-300 hover:border-gold/40 hover:text-gold">
                  <ChevronRight className="h-5 w-5" />
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};
